function normalizeCpfCnpj(value) {
  if (value === undefined || value === null) return '';
  if (typeof value === 'object') {
    const v = value.number ?? value.value ?? '';
    return String(v).replace(/\D/g, '');
  }

  return String(value).replace(/\D/g, '');
}

/**
 * Normaliza campos CPF/CNPJ presentes em `customFields` aplicando
 * `normalizeCpfCnpj` sobre os valores em `data` e escrevendo no
 * `formattedData` (mutável). Retorna o `formattedData` modificado.
 */
export function normalizeCpfCnpjFields(formattedData, data, customFields) {
  if (!customFields || !customFields.length) return formattedData;

  const cpfCnpjFields = customFields
    .filter((f) => f && (f.type === 'CPF' || f.type === 'CNPJ'))
    .map((f) => f.name);

  cpfCnpjFields.forEach((fieldName) => {
    const val = data[fieldName];
    if (val) formattedData[fieldName] = normalizeCpfCnpj(val);
  });

  return formattedData;
}

export default normalizeCpfCnpj;
